// Polyfork clips: JSON rotation tracks for its shared Mixamo skeleton, plus one hips track baked at a 0.95 m hip.
import * as THREE from 'three';

const BAKED_HIP = 0.95;

// An AnimationClip bound by bone name (so it plays on every clone), on the spot, with the hips bob scaled from the
// baked hip height to this body's rest hips `[x, y, z]`. Seated clips pass `inPlace: false` to keep the hips x/z
// offsets (scaled the same way), which carry the hips back onto the seat.
export function clipFromJson(raw, restHips, { inPlace = true } = {}) {
  const tracks = [];
  for (const [bone, values] of Object.entries(raw.tracks))
    if (values.length)
      tracks.push(
        new THREE.QuaternionKeyframeTrack(
          `${bone}.quaternion`,
          raw.times,
          Float32Array.from(values),
        ),
      );
  const [x, y, z] = restHips,
    ratio = y / BAKED_HIP,
    pos = new Float32Array(raw.hips.length);
  for (let i = 0; i < raw.hips.length; i += 3) {
    const [dx, dy, dz] = raw.hips.slice(i, i + 3).map((v) => v * ratio);
    pos.set(inPlace ? [x, y + dy, z] : [x + dx, y + dy, z + dz], i);
  }
  tracks.push(new THREE.VectorKeyframeTrack('Hips.position', raw.times, pos));
  return new THREE.AnimationClip(raw.name, -1, tracks);
}
